// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__3fVO0","col":"CardReaderDesc_col__sCWvz","label":"CardReaderDesc_label__2TQzi"};